import React, { Fragment, useEffect } from "react";
import { useOutlet } from "react-router";
import { ToastContainer } from "react-toastify";
import DemoPage from "../pages/DemoPage";
import { Backtotop1 } from "./Backtotop/Backtotop";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import Rightside from "./Rightside/Rightside";
import SideBar from "./SideBar/SideBar";
import { DASHBOARD_MENU } from "./SideBar/SideMenu";
import { Gotobottom1 } from "./Gotobottom/Gotobottom";

const AppLayout = ({ SideMenuLinks = DASHBOARD_MENU() }) => {
  const outlet = useOutlet();

  useEffect(() => {
    const body = document.querySelector("body");
    body.classList.remove("error-1", "app", "sidebar-mini", "landing-page", "horizontalmenu");
    body.classList.add("main-body", "leftmenu");
  }, []);

  const closeSidebar = () => {
    const sidebarRight = document.querySelector(".sidebar-right");
    const body = document.querySelector("body");
    sidebarRight.classList.remove("sidebar-open");
    body.classList.remove("main-sidebar-show");
  };

  return (
    <Fragment>
      <div className="horizontalMenucontainer" style={{marginBottom: '2%'}}>
        <div className="page">
          <Header />
          <SideBar menu={SideMenuLinks} />
          <div className="main-content side-content">
            <div className="main-container container-fluid" onClick={closeSidebar}>
              <div className="inner-body">{outlet || <DemoPage />}</div>
            </div>
          </div>
          <Rightside />
        </div>
        <Gotobottom1 />
        <Backtotop1 />
        <ToastContainer />
      </div>
      <Footer />
    </Fragment>
  );
};

export default AppLayout;
